export type CarModel = {
  slug: string;
  brand: string;
  model: string;
  /** Typiskt begagnatpris i kr som styr kalkylatorns startbelopp. */
  typicalLoan: number;
  priceFrom: number;
  priceTo: number;
  note: string;
};

const M = (
  slug: string,
  brand: string,
  model: string,
  typicalLoan: number,
  priceFrom: number,
  priceTo: number,
  note: string,
): CarModel => ({ slug, brand, model, typicalLoan, priceFrom, priceTo, note });

export const CAR_MODELS: CarModel[] = [
  M("volvo-xc60", "Volvo", "XC60", 250000, 150000, 600000, "Sveriges mest sålda SUV med starka andrahandsvärden."),
  M("volvo-xc40", "Volvo", "XC40", 250000, 180000, 550000, "Kompakt SUV som är populär både som bensin och helelektrisk."),
  M("volvo-v60", "Volvo", "V60", 200000, 120000, 500000, "Klassisk svensk kombi med låg värdeminskning."),
  M("volvo-v70", "Volvo", "V70", 90000, 40000, 180000, "Prisvärd familjekombi på begagnatmarknaden."),
  M("volvo-v90", "Volvo", "V90", 250000, 150000, 600000, "Rymlig premiumkombi för långa resor."),
  M("volvo-xc90", "Volvo", "XC90", 300000, 180000, 800000, "Sjusitsig SUV som ofta finansieras med billån."),
  M("volvo-s60", "Volvo", "S60", 180000, 100000, 450000, "Sedanmodell med samma teknik som V60."),
  M("volvo-ex30", "Volvo", "EX30", 300000, 250000, 450000, "Liten elbil med låg driftkostnad."),
  M("tesla-model-3", "Tesla", "Model 3", 300000, 200000, 500000, "Populäraste elbilen bland svenska privatköpare."),
  M("tesla-model-y", "Tesla", "Model Y", 350000, 250000, 600000, "Rymlig el-SUV med stort utbud på begagnatmarknaden."),
  M("volkswagen-golf", "Volkswagen", "Golf", 130000, 50000, 350000, "Sveriges mest sålda småbil genom tiderna."),
  M("volkswagen-passat", "Volkswagen", "Passat", 150000, 60000, 400000, "Bekväm familjekombi med låg bränsleförbrukning."),
  M("volkswagen-tiguan", "Volkswagen", "Tiguan", 200000, 120000, 450000, "Mellanstor SUV med stort utbud."),
  M("volkswagen-id4", "Volkswagen", "ID.4", 280000, 200000, 450000, "Elektrisk familje-SUV."),
  M("volkswagen-polo", "Volkswagen", "Polo", 110000, 50000, 250000, "Billig i drift och populär som första bil."),
  M("audi-a4", "Audi", "A4", 180000, 80000, 500000, "Premiumsedan och kombi med bra utrustning."),
  M("audi-a6", "Audi", "A6", 220000, 100000, 600000, "Större premiumbil, ofta tjänstebil från början."),
  M("audi-q5", "Audi", "Q5", 250000, 150000, 600000, "Premium-SUV med fyrhjulsdrift."),
  M("bmw-3-serie", "BMW", "3-serie", 200000, 90000, 550000, "Körglad premiumbil med starkt andrahandsvärde."),
  M("bmw-5-serie", "BMW", "5-serie", 230000, 100000, 650000, "Rymlig premiumbil för långkörning."),
  M("bmw-x3", "BMW", "X3", 260000, 150000, 650000, "Premium-SUV i mellanklass."),
  M("mercedes-c-klass", "Mercedes-Benz", "C-klass", 220000, 100000, 600000, "Premiumbil med hög komfortnivå."),
  M("mercedes-e-klass", "Mercedes-Benz", "E-klass", 250000, 110000, 700000, "Stor premiumbil, vanlig som tjänstebil."),
  M("toyota-rav4", "Toyota", "RAV4", 250000, 150000, 500000, "Hybrid-SUV med mycket låg driftkostnad."),
  M("toyota-corolla", "Toyota", "Corolla", 180000, 90000, 350000, "Driftsäker hybrid med låg förbrukning."),
  M("toyota-yaris", "Toyota", "Yaris", 140000, 70000, 300000, "Liten hybrid som passar stadskörning."),
  M("kia-niro", "Kia", "Niro", 230000, 150000, 400000, "Elbil och hybrid med lång garanti."),
  M("kia-ceed", "Kia", "Ceed", 150000, 80000, 300000, "Prisvärd familjebil med 7 års garanti."),
  M("hyundai-tucson", "Hyundai", "Tucson", 230000, 140000, 450000, "Välutrustad SUV i mellanklass."),
  M("hyundai-ioniq-5", "Hyundai", "Ioniq 5", 320000, 250000, 550000, "Snabbladdande elbil med rymlig kupé."),
  M("skoda-octavia", "Skoda", "Octavia", 160000, 70000, 400000, "Extremt rymlig kombi för pengarna."),
  M("skoda-kodiaq", "Skoda", "Kodiaq", 240000, 150000, 500000, "Sjusitsig SUV till lägre pris än premiummärkena."),
  M("skoda-superb", "Skoda", "Superb", 190000, 90000, 450000, "Marknadens rymligaste kombi i sin klass."),
  M("ford-kuga", "Ford", "Kuga", 190000, 100000, 400000, "Laddhybrid-SUV med låg förmånsbeskattning."),
  M("ford-focus", "Ford", "Focus", 120000, 50000, 300000, "Prisvärd och körglad familjebil."),
  M("nissan-qashqai", "Nissan", "Qashqai", 190000, 90000, 400000, "En av Europas mest sålda kompakt-SUV:ar."),
  M("nissan-leaf", "Nissan", "Leaf", 150000, 90000, 300000, "Prisvärd begagnad elbil för pendling."),
  M("peugeot-3008", "Peugeot", "3008", 200000, 110000, 400000, "Designstark SUV med hybridalternativ."),
  M("renault-clio", "Renault", "Clio", 120000, 60000, 250000, "Liten och billig i drift."),
  M("mazda-cx-5", "Mazda", "CX-5", 220000, 130000, 450000, "Driftsäker SUV med hög byggkvalitet."),
];

export function getCarModel(slug: string) {
  return CAR_MODELS.find((c) => c.slug === slug) ?? null;
}

export type LoanPurpose = {
  slug: string;
  name: string;
  h1: string;
  title: string;
  description: string;
  intro: string;
  amount: number;
  faq: { q: string; a: string }[];
};

export const LOAN_PURPOSES: LoanPurpose[] = [
  {
    slug: "renovering",
    name: "renovering",
    h1: "Lån till renovering – jämför räntor 2026",
    title: "Lån till renovering – jämför räntor och månadskostnad 2026",
    description:
      "Ska du renovera kök, badrum eller fasad? Jämför lån till renovering utan säkerhet, se månadskostnad och ansök med en kreditupplysning.",
    intro:
      "Ett renoveringslån är ett vanligt privatlån utan säkerhet, vilket gör att du slipper pantsätta bostaden och får pengarna på kontot inom några dagar. Ett badrum kostar i regel 150 000–250 000 kr och ett kök 100 000–300 000 kr.",
    amount: 150000,
    faq: [
      {
        q: "Är det bättre att utöka bolånet?",
        a: "Bolån har lägre ränta men kräver utrymme i bostadens värde och en ny värdering. Ett privatlån är snabbare och passar renoveringar upp till ett par hundra tusen.",
      },
      {
        q: "Får jag ROT-avdrag?",
        a: "Ja, ROT-avdraget gäller oavsett hur du finansierar renoveringen. Du får dra av 30 procent av arbetskostnaden, max 50 000 kr per person och år.",
      },
      {
        q: "Hur lång löptid ska jag välja?",
        a: "Matcha löptiden mot renoveringens livslängd. Ett badrum håller 25–30 år, men de flesta väljer 5–10 års återbetalningstid för att hålla nere räntekostnaden.",
      },
    ],
  },
  {
    slug: "brollop",
    name: "bröllop",
    h1: "Lån till bröllop – finansiera stora dagen",
    title: "Lån till bröllop – jämför räntor och månadskostnad | Svensk Låneguide",
    description:
      "Ett svenskt bröllop kostar i snitt 100 000 kr. Jämför lån till bröllop, se månadskostnad och hitta lägst ränta utan säkerhet.",
    intro:
      "Ett bröllop i Sverige kostar i genomsnitt runt 100 000 kr med lokal, mat, fotograf och kläder. Ett privatlån utan säkerhet gör att du kan boka i tid och betala av i lugn takt efteråt.",
    amount: 100000,
    faq: [
      {
        q: "Hur mycket bör vi låna till bröllopet?",
        a: "Låna bara det som saknas efter eget sparande. En bra tumregel är att månadskostnaden inte ska överstiga 10 procent av hushållets nettoinkomst.",
      },
      {
        q: "Kan vi söka tillsammans?",
        a: "Ja, en gemensam ansökan med två inkomster ger nästan alltid lägre ränta än om en av er söker ensam.",
      },
      {
        q: "Kan vi lösa lånet i förtid?",
        a: "Ja. Får ni bröllopsgåvor i pengar kan ni lösa lånet direkt utan extra kostnad – räntan slutar löpa samma dag.",
      },
    ],
  },
  {
    slug: "tandvard",
    name: "tandvård",
    h1: "Lån till tandvård – jämför finansiering",
    title: "Lån till tandvård – jämför räntor på tandvårdslån 2026",
    description:
      "Implantat, tandreglering eller krona? Jämför lån till tandvård, se månadskostnad och ansök utan säkerhet med en kreditupplysning.",
    intro:
      "Tandvård är sällan gratis efter 24 års ålder. Ett implantat kostar 25 000–45 000 kr och tandreglering 30 000–70 000 kr. Ett privatlån är ofta billigare än klinikens egen delbetalning.",
    amount: 40000,
    faq: [
      {
        q: "Är klinikens delbetalning billigare?",
        a: "Sällan. Kliniker samarbetar ofta med kreditgivare som tar 15–25 procent ränta plus avgifter. Jämför alltid med ett privatlån innan du signerar på plats.",
      },
      {
        q: "Vad täcker högkostnadsskyddet?",
        a: "Statligt tandvårdsstöd ger 50 procent ersättning mellan 3 000 och 15 000 kr och 85 procent över 15 000 kr per år. Resten betalar du själv.",
      },
      {
        q: "Hur snabbt får jag pengarna?",
        a: "De flesta långivare betalar ut inom 1–3 bankdagar efter signering med BankID.",
      },
    ],
  },
  {
    slug: "resa",
    name: "resa",
    h1: "Lån till resa – jämför räntor innan du bokar",
    title: "Lån till resa – jämför räntor och månadskostnad | Svensk Låneguide",
    description:
      "Jämför lån till resa och semester. Se månadskostnad, ränta och totalkostnad innan du bokar – ansök kostnadsfritt online.",
    intro:
      "En längre resa kostar ofta 30 000–80 000 kr för en familj. Ett privatlån ger fasta månadsbetalningar i stället för dyr kreditkortsskuld – men räkna alltid på totalkostnaden först.",
    amount: 40000,
    faq: [
      {
        q: "Är det klokt att låna till semester?",
        a: "Låna bara om du säkert klarar månadskostnaden och lånet är avbetalat innan nästa resa. En resa är konsumtion, inte en investering.",
      },
      {
        q: "Privatlån eller kreditkort?",
        a: "Kreditkort är bra för betalskydd och bonus om du betalar av hela saldot varje månad. Ska skulden ligga kvar är privatlånets ränta nästan alltid lägre.",
      },
      {
        q: "Hur kort löptid bör jag välja?",
        a: "Välj kortast möjliga löptid du klarar – gärna 1–3 år – så att räntekostnaden hålls nere.",
      },
    ],
  },
  {
    slug: "flytt",
    name: "flytt",
    h1: "Lån till flytt – täck deposition och flyttfirma",
    title: "Lån till flytt – jämför räntor på flyttlån 2026",
    description:
      "Flyttfirma, deposition och nya möbler kostar. Jämför lån till flytt, se månadskostnad och hitta lägst ränta utan säkerhet.",
    intro:
      "En flytt kostar snabbt 30 000–60 000 kr med flyttfirma, deposition, magasinering och nya möbler. Ett privatlån utan säkerhet täcker allt på en gång.",
    amount: 40000,
    faq: [
      {
        q: "Vad kostar en flyttfirma?",
        a: "En tvårumslägenhet inom samma stad kostar 6 000–12 000 kr efter RUT-avdrag. Längre flyttar och villor blir dyrare.",
      },
      {
        q: "Kan jag använda lånet till deposition?",
        a: "Ja, ett privatlån är fritt att använda. Depositionen får du normalt tillbaka när du flyttar ut och kan då lösa lånet i förtid.",
      },
      {
        q: "Får jag RUT-avdrag på flytten?",
        a: "Ja, flytttjänster ger 50 procent RUT-avdrag på arbetskostnaden, upp till gällande takbelopp per person och år.",
      },
    ],
  },
  {
    slug: "hasten",
    name: "häst",
    h1: "Lån till häst – köp, transport och stall",
    title: "Lån till häst – jämför räntor på hästlån | Svensk Låneguide",
    description:
      "Jämför lån till hästköp, hästtransport och stallutrustning. Se månadskostnad och ränta – ansök kostnadsfritt online.",
    intro:
      "En ridhäst kostar ofta 40 000–150 000 kr och därtill kommer transport, utrustning och veterinärbesiktning. Ett privatlån utan säkerhet gör det möjligt att slå till när rätt häst dyker upp.",
    amount: 80000,
    faq: [
      {
        q: "Räkna med löpande kostnader",
        a: "Stallplats, foder, hovslagare och försäkring kostar normalt 4 000–8 000 kr i månaden. Lägg månadskostnaden för lånet ovanpå det innan du bestämmer dig.",
      },
      {
        q: "Kan jag låna till hästtransport också?",
        a: "Ja, ett privatlån är fritt att använda och kan täcka både häst, transport och utrustning i samma lån.",
      },
      {
        q: "Behöver jag besiktiga hästen?",
        a: "En veterinärbesiktning kostar 3 000–8 000 kr och rekommenderas alltid vid köp över 30 000 kr.",
      },
    ],
  },
  {
    slug: "bat",
    name: "båt",
    h1: "Lån till båt – jämför båtlån utan säkerhet",
    title: "Båtlån – jämför räntor och månadskostnad 2026 | Svensk Låneguide",
    description:
      "Jämför lån till båt utan säkerhet. Se ränta, månadskostnad och villkor för båtlån upp till 600 000 kr.",
    intro:
      "Ett båtlån utan säkerhet betyder att du inte behöver pantsätta båten och kan köpa privat lika enkelt som av handlare. Vanliga lånebelopp ligger mellan 100 000 och 400 000 kr.",
    amount: 200000,
    faq: [
      {
        q: "Båtlån med eller utan säkerhet?",
        a: "Lån med båten som säkerhet har lägre ränta men kräver värdering, registrering och ofta 20 procent kontantinsats. Blancolån går snabbare och fungerar även vid privatköp.",
      },
      {
        q: "Vilka löpande kostnader tillkommer?",
        a: "Räkna med försäkring, hamnplats, vinterförvaring och service – ofta 15 000–40 000 kr per år för en motorbåt i mellanklass.",
      },
      {
        q: "Hur lång löptid är rimlig?",
        a: "5–10 år är vanligt. Längre löptid än båtens förväntade livslängd bör undvikas.",
      },
    ],
  },
  {
    slug: "mc",
    name: "motorcykel",
    h1: "Lån till MC – jämför mc-lån 2026",
    title: "MC-lån – jämför räntor på lån till motorcykel | Svensk Låneguide",
    description:
      "Jämför lån till motorcykel utan säkerhet. Se ränta, månadskostnad och villkor – ansök kostnadsfritt och få bud från flera banker.",
    intro:
      "En ny motorcykel kostar 60 000–200 000 kr och begagnat betydligt mindre. Ett blancolån gör att du kan köpa privat och betala kontant på plats.",
    amount: 80000,
    faq: [
      {
        q: "Behöver jag kontantinsats?",
        a: "Nej, ett privatlån utan säkerhet kräver ingen kontantinsats – till skillnad från handlarens egen finansiering som ofta kräver 20 procent.",
      },
      {
        q: "Är MC-lån dyrare än billån?",
        a: "Räntan sätts efter din ekonomi, inte efter fordonstyp, när lånet är utan säkerhet. Villkoren blir därför desamma som för ett vanligt privatlån.",
      },
      {
        q: "Kan jag amortera extra på sommaren?",
        a: "Ja, extraamortering är alltid tillåtet och kostnadsfritt enligt konsumentkreditlagen.",
      },
    ],
  },
  {
    slug: "korkort",
    name: "körkort",
    h1: "Lån till körkort – finansiera körkortet",
    title: "Lån till körkort – jämför räntor och CSN-alternativ 2026",
    description:
      "Ett B-körkort kostar 15 000–25 000 kr. Jämför lån till körkort, se månadskostnad och läs om CSN:s körkortslån.",
    intro:
      "Ett B-körkort kostar i dag 15 000–25 000 kr med lektioner, prov och böcker. Uppfyller du inte CSN:s krav för körkortslån är ett vanligt privatlån ofta enda alternativet.",
    amount: 25000,
    faq: [
      {
        q: "Vem kan få CSN:s körkortslån?",
        a: "CSN:s körkortslån riktar sig främst till arbetslösa i vissa åldersgrupper. Uppfyller du inte kraven är ett privatlån alternativet.",
      },
      {
        q: "Hur mycket kostar det per månad?",
        a: "25 000 kr på 3 år till 12 procent ränta ger cirka 830 kr i månaden före avgifter.",
      },
      {
        q: "Kan jag låna som student?",
        a: "De flesta långivare kräver en årsinkomst på minst 120 000–180 000 kr. Studiemedel räknas sällan som inkomst, men en medsökande löser det ofta.",
      },
    ],
  },
  {
    slug: "solceller",
    name: "solceller",
    h1: "Lån till solceller – räkna på återbetalningen",
    title: "Lån till solceller – jämför räntor och grönt avdrag 2026",
    description:
      "Jämför lån till solceller. Se månadskostnad, gröna avdraget och hur snabbt anläggningen betalar sig.",
    intro:
      "En villaanläggning på 10 kW kostar 120 000–180 000 kr före det gröna avdraget på 20 procent av totalkostnaden. Med dagens elpriser är återbetalningstiden ofta 8–12 år.",
    amount: 150000,
    faq: [
      {
        q: "Hur fungerar gröna avdraget?",
        a: "Du får 20 procent i avdrag på arbets- och materialkostnad för solceller, upp till 50 000 kr per person och år. Installatören drar av det direkt på fakturan.",
      },
      {
        q: "Bolån eller privatlån?",
        a: "Har du utrymme i bolånet är det billigare. Saknas utrymme eller vill du undvika ny värdering är ett privatlån snabbare.",
      },
      {
        q: "Ökar solceller husets värde?",
        a: "Ja, en installerad anläggning brukar räknas in i värderingen, även om ökningen sällan motsvarar hela investeringen.",
      },
    ],
  },
  {
    slug: "oforutsedda-utgifter",
    name: "oförutsedda utgifter",
    h1: "Lån till oförutsedda utgifter",
    title: "Lån till oförutsedda utgifter – snabb utbetalning | Svensk Låneguide",
    description:
      "Trasig tvättmaskin, bilreparation eller veterinär? Jämför lån till oförutsedda utgifter med snabb utbetalning och låg ränta.",
    intro:
      "När kylen går sönder eller bilen måste repareras behövs pengarna direkt. Nedan jämför du långivare med snabbt besked – men jämför alltid räntan innan du signerar.",
    amount: 25000,
    faq: [
      {
        q: "Hur snabbt kan jag få pengarna?",
        a: "Flera långivare betalar ut samma dag vid signering med BankID under bankernas öppettider.",
      },
      {
        q: "Bör jag använda kreditkort i stället?",
        a: "Har du räntefri kredit och kan betala hela saldot inom perioden är kortet billigast. Annars är privatlånets ränta lägre.",
      },
      {
        q: "Hur undviker jag samma situation igen?",
        a: "Bygg upp en buffert på 2–3 månadsutgifter på ett sparkonto med fri uttagsrätt när lånet är återbetalat.",
      },
    ],
  },
  {
    slug: "studier",
    name: "studier",
    h1: "Lån till studier utöver CSN",
    title: "Lån till studier – komplettera CSN med privatlån | Svensk Låneguide",
    description:
      "Räcker inte CSN? Jämför privatlån till studier, se månadskostnad och krav på inkomst – ansök kostnadsfritt online.",
    intro:
      "CSN täcker sällan hela levnadskostnaden, särskilt vid studier utomlands eller utbildningar med kursavgifter. Ett privatlån kan komplettera – men räntan är betydligt högre än CSN:s.",
    amount: 50000,
    faq: [
      {
        q: "Är CSN alltid billigare?",
        a: "Ja, CSN:s låneränta ligger långt under privatlånens. Utnyttja alltid CSN maximalt först.",
      },
      {
        q: "Kan jag få privatlån som student?",
        a: "De flesta långivare kräver 120 000–180 000 kr i årsinkomst. Extrajobb räknas, medan studiemedel oftast inte gör det. En medsökande ökar chansen kraftigt.",
      },
      {
        q: "Kan jag skjuta upp återbetalningen?",
        a: "Nej, ett privatlån amorteras från första månaden. Det skiljer det från CSN där återbetalningen startar efter studierna.",
      },
    ],
  },
];

export function getPurpose(slug: string) {
  return LOAN_PURPOSES.find((p) => p.slug === slug) ?? null;
}
